// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607301950/js/" + chunkId + "." + {"44":"da2a11cd","225":"21e867ea","481":"0cb6bd44","486":"b28863fb","770":"3393abf8"}[chunkId] + ".0.8105072912603535.chunk.js";
};